const isSubstring = (name, queryString) => {
    return name === null || name === void 0 ? void 0 : name.toLowerCase().includes(queryString.toLowerCase().trim());
};
export default isSubstring;
//# sourceMappingURL=utils.js.map